import script from "./PolicyEmailHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyEmailHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./PolicyEmailHistoryModal.vue?vue&type=style&index=0&id=56403199&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56403199"]])

export default __exports__